import type { RangeFilter } from '../../../../../hooks/types.ts';

export const extractRange = (range: RangeFilter = []) => {
  return {
    min: range?.[0] && range[0] !== '' && !Number.isNaN(Number(range[0])) ? Number(range[0]) : undefined,
    max: range?.[1] && range[1] !== '' && !Number.isNaN(Number(range[1])) ? Number(range[1]) : undefined,
  };
};
